var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TabPanel } from '@mui/lab';
import { Badge, Box, IconButton, ToggleButton, ToggleButtonGroup, Typography, useTheme } from '@mui/material';
import { BubbleChatIcon } from 'hugeicons-react';
import { Fragment, useState } from 'react';
import { useFindMachineMutation } from '../../../../../../application/features/machines/machine-api';
import useTranslate from '../../../../../../localization/helpers';
import MachineDocuments from '../../../../../components/MachineDocuments';
var ClientMachine = function (_a) {
    var _b = _a.machines, machines = _b === void 0 ? [] : _b;
    var theme = useTheme();
    var translate = useTranslate().translate;
    var _c = __read(useState('All'), 2), viewMode = _c[0], setViewMode = _c[1];
    var _d = __read(useState(false), 2), machineDocumentsModalOpen = _d[0], setMachineDocumentsModalOpen = _d[1];
    var _e = __read(useFindMachineMutation(), 2), findMachine = _e[0], machine = _e[1].data;
    var onViewModeChanged = function (viewMode) {
        viewMode && setViewMode(viewMode);
    };
    var onStartChat = function (machineId) {
        findMachine({ id: machineId });
        setMachineDocumentsModalOpen(true);
    };
    return (_jsxs(Box, { sx: { width: '100%' }, children: [_jsx(TabPanel, { sx: { paddingTop: 0 }, value: 'Assets', children: _jsxs(Box, { sx: {
                        marginTop: '6px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        width: '100%',
                        borderRadius: '8px'
                    }, children: [_jsxs(ToggleButtonGroup, { sx: { my: { xs: 1, md: 1 }, maxHeight: 36, width: { xs: '100%', md: '100%' } }, fullWidth: true, value: viewMode, exclusive: true, onChange: function (_, value) { return onViewModeChanged(value); }, "aria-label": 'toggle button group', children: [_jsx(ToggleButton, { size: 'small', value: 'All', "aria-label": 'All', sx: {
                                        borderBottomLeftRadius: '8px !important',
                                        borderTopLeftRadius: '8px !important',
                                        flex: '1 1 auto',
                                        '&.Mui-selected': {
                                            backgroundColor: ' #009983 !important'
                                        }
                                    }, children: _jsxs(Box, { display: 'flex', flexDirection: 'row', gap: machines.length > 0 ? 3 : 0, alignItems: 'center', children: [translate('common.all'), _jsx(Badge, { badgeContent: machines.length, color: 'default', overlap: 'circular', sx: {
                                                    '& .MuiBadge-badge': {
                                                        backgroundColor: '#E4E6EB',
                                                        color: '#161C24'
                                                    }
                                                } })] }) }), _jsx(ToggleButton, { size: 'small', disabled: true, value: 'My Speciality', "aria-label": 'My Speciality', sx: {
                                        fontSize: 13,
                                        textTransform: 'none',
                                        borderBottomRightRadius: '8px !important',
                                        borderTopRightRadius: '8px !important',
                                        flex: '1 1 auto',
                                        '&.Mui-selected': {
                                            backgroundColor: ' #009983 !important'
                                        }
                                    }, children: _jsxs(Box, { display: 'flex', flexDirection: 'row', gap: machines.length > 0 ? 3 : 0, alignItems: 'center', children: [translate('clients.mySpeciality'), _jsx(Badge, { badgeContent: machines.length, color: 'default', overlap: 'circular', sx: {
                                                    '& .MuiBadge-badge': {
                                                        backgroundColor: '#E4E6EB',
                                                        color: '#161C24'
                                                    }
                                                } })] }) })] }), _jsx(Box, { sx: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '10px',
                                width: '100%',
                                borderRadius: '8px',
                                height: '100%'
                            }, children: viewMode === 'All' && (_jsx(Fragment, { children: _jsx(Box, { sx: {
                                        display: 'flex',
                                        flexDirection: 'column',
                                        width: '100%',
                                        borderRadius: '8px',
                                        height: '80vh'
                                    }, children: _jsx(Box, { sx: {
                                            flexGrow: 1,
                                            overflowY: 'auto',
                                            paddingRight: '10px',
                                            paddingBottom: '150px'
                                        }, children: machines.map(function (machine, index) { return (_jsx(Box, { sx: { display: 'flex', flexDirection: 'column' }, children: _jsx(Box, { sx: { display: 'flex', alignItems: 'center', marginTop: '14px' }, children: _jsx(Box, { display: 'flex', flexDirection: 'column', gap: 1, width: '100%', children: _jsxs(Box, { display: 'flex', justifyContent: 'space-between', flexDirection: 'row', alignItems: 'center', children: [_jsx(Typography, { variant: 'subtitle1', children: machine.name }), _jsx(IconButton, { size: 'medium', color: 'primary', disabled: !machine.hasDocuments, onClick: function () { return onStartChat(machine.id); }, children: _jsx(BubbleChatIcon, {}) })] }) }) }) }, index)); }) }) }) })) })] }) }), machineDocumentsModalOpen && machine && (_jsx(MachineDocuments, { isOpen: machineDocumentsModalOpen, setIsOpen: setMachineDocumentsModalOpen, machine: machine, onStartChat: function () { return setMachineDocumentsModalOpen(false); } }))] }));
};
export default ClientMachine;
